module.exports = __webpack_public_path__ + "img/tj.2c10db83.svg";